import React from 'react';
import { Box, HStack, Text, VStack } from '@chakra-ui/react';

import { useTranslations } from '../../../../../../../contexts/LocalizationContext';
import { ScannerMode } from '../../../../../../RelevoAssignment/model/enums/scanner-mode.enum';
import { useDepositResultSummary } from '../../../../hooks/use-deposit-result-summary.hook';

export const ExpiredItemsSummary = () => {
  const translations = useTranslations();
  const { mode, itemsExpired, returnedItemsAmount, expiredItemsAmount, deposit } = useDepositResultSummary();

  if (!(mode === ScannerMode.DEPOSIT_RETURN && itemsExpired)) {
    return null;
  }

  return (
    <VStack align="start" spacing={2} w="100%" pb={4}>
      <HStack w="100%" spacing="auto">
        <Box w="50%">{translations('return_deposit_expired_items_deposit_summary')}</Box>
        <Box w="50%">
          <Text>{returnedItemsAmount.format(deposit.currency)}</Text>
        </Box>
      </HStack>
      <HStack w="100%" spacing="auto">
        <Box w="50%">{translations('return_deposit_expired_items_eco_balance_summary')}</Box>
        <Box w="50%">
          <Text>{expiredItemsAmount.format(deposit.currency)}</Text>
        </Box>
      </HStack>
    </VStack>
  );
};
